export const SpeakingCriteria = [
  {
    vName: "Độ trôi chảy và mạch lạc",
    eName: "Fluency and coherence",
    apiName: "fluency_and_coherence",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment: "• Essentially none.\n• Speech is totally incoherent.",
        vComment:
          "• Học viên không thể giao tiếp và truyền đạt \n• Bài nói hoàn toàn rời rạc",
        band: 1,
      },
      {
        eComment:
          "• Lengthy pauses before nearly every word.\n• Isolated words may be recognisable but speech is of virtually no communicative significance.",
        vComment:
          "• Khi trình bày, có các khoảng dừng dài trước hầu hết các từ\n• Học viên có thể nói các từ đơn nhưng khả năng truyền đạt thấp, hầu như không có ý nghĩa giao tiếp",
        band: 2,
      },
      {
        eComment:
          "• Frequent, sometimes long, pauses occur while candidate searches for words.\n• Limited ability to link simple sentences and go beyond simple responses to questions.\n• Frequently unable to convey basic message.",
        vComment:
          "• Khi học viên trình bày còn có những khoảng dừng dài và thường xuyên để tìm từ vựng\n• Khả năng liên kết các câu đơn còn hạn chế\n• Chỉ đưa ra được những câu trả lời đơn giản và thường không truyền tải được thông điệp cơ bản",
        band: 3,
      },
      {
        eComment:
          "• Unable to keep going without noticeable pauses.\n• Speech may be slow with frequent repetition.\n• Often self-corrects.\n• Can link simple sentences but often with repetitious use of connectives.\n• Some breakdowns in coherence.",
        vComment:
          "• Trong lúc trả lời vẫn có những khoảng dừng đáng chú ý, tốc độ nói của học viên khá chậm, thường xuyên bị lặp và tự sửa lỗi\n• Học viên có thể liên kết được các câu cơ bản nhưng còn sử dụng lặp đi lặp lại các phép liên kết đơn giản, tính mạch lạc vẫn còn bị gián đoạn.",
        band: 4,
      },
      {
        eComment:
          "• Usually able to keep going, but relies on repetition and self-correction to do so and/or on slow speech.\n• Hesitations are often associated with mid-sentence searches for fairly basic lexis and grammar.\n• Overuse of certain discourse markers, connectives and other cohesive features.\n• More complex speech usually causes disfluency but simpler language may be produced fluently.",
        vComment:
          "• Học viên thường xuyên duy trì được độ trôi chảy của lời nói nhưng phải lặp lại, tự sửa lỗi và nói chậm để có thể nói liên tục\n• Học viên thường ngập ngừng để tìm kiếm những từ vựng và ngữ pháp khá căn bản\n• Học viên có thể lạm dụng (sử dụng quá mức) một số từ nối, phép nối và cụm từ nối\n• Học viên tạo ra được những lời nói đơn giản và lưu loát, nhưng việc truyền đạt bị phức tạp hơn nên gây ra các vấn đề về độ trôi chảy",
        band: 5,
      },
      {
        eComment:
          "• Able to keep going and demonstrates a willingness to produce long turns.\n• Coherence may be lost at times as a result of hesitation, repetition and/or self-correction.\n• Uses a range of spoken discourse markers, connectives and cohesive features though not always appropriately.",
        vComment:
          "• Học viên có thể mở rộng câu trả lời, mặc dù đôi khi có thể mất độ mạch lạc do thỉnh thoảng lặp lại, tự sửa lỗi hoặc do ngập ngừng\n• Sử dụng nhiều các phép nối và cụm từ nối nhưng không phải lúc nào cũng thích hợp",
        band: 6,
      },
      {
        eComment:
          "• Able to keep going and readily produce long turns without noticeable effort.\n• Some hesitation, repetition and/or self-correction may occur, often mid-sentence and indicate problems with accessing appropriate language. However, these will not affect coherence.\n• Flexible use of spoken discourse markers, connectives and cohesive features.",
        vComment:
          "• Học viên có thể mở rộng, kéo dài câu nói mà không cần nỗ lực nhiều hoặc mất tính mạch lạc\n• Đôi khi có thể thể hiện sự ngập ngừng, một số sự lặp lại và / hoặc tự điều chỉnh, sửa lỗi ở giữa câu nói, liên quan đến việc tìm kiếm ngôn ngữ phù hợp nhưng không ảnh hưởng đến độ mạch lạc\n• Sử dụng nhiều, đa dạng và linh hoạt các phép nối cũng như cụm từ nối",
        band: 7,
      },
      {
        eComment:
          "• Fluent with only very occasional repetition or self-correction.\n• Hesitation may occasionally be used to find words or grammar, but most will be content related.\n• Topic development is coherent, appropriate and relevant.",
        vComment:
          "• Học viên duy trì bài nói một cách trôi chảy, chỉ thỉnh thoảng lặp từ hoặc tự sửa lỗi hay ngập ngừng do tìm nội dung, ý diễn đạt chứ hiếm khi phải dừng để tìm từ ngữ hay ngữ pháp \n• Phát triển các chủ đề một cách mạch lạc và phù hợp",
        band: 8,
      },
      {
        eComment:
          "• Fluent with only very occasional repetition or self-correction.\n• Any hesitation that occurs is used only to prepare the content of the next utterance and not to find words or grammar.\n• Speech is situationally appropriate and cohesive features are fully acceptable.\n• Topic development is fully coherent and appropriately extended.",
        vComment:
          "• Học viên nói trôi chảy và hiếm khi lặp lại hay tự điều chỉnh, sửa lỗi\n• Mọi sự do dự, ngập ngừng trong lúc nói đều liên quan đến nội dung, không phải là tìm từ hoặc ngữ pháp\n• Học viên nói mạch lạc, phù hợp với ngữ cảnh, sử dụng các đặc trưng liên kết một cách hoàn toàn thích hợp\n• Phát triển các chủ đề một cách mạch lạc, đầy đủ và hợp lý",
        band: 9,
      },
    ],
  },
  {
    vName: "Vốn từ vựng",
    eName: "Lexical resource",
    apiName: "lexical_resource",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• No resource bar a few isolated words.\n• No communication possible.",
        vComment:
          "• Học viên không có vốn từ vựng hoặc chỉ biết ít từ đơn\n• Học viên không có sự giao tiếp",
        band: 1,
      },
      {
        eComment:
          "• Very limited resource. Utterances consist of isolated words or memorised utterances.\n• Little communication possible without the support of mime or gesture.",
        vComment:
          "• Học viên có rất ít vốn từ vựng. Học viên chỉ nói được những từ đơn, riêng biệt hoặc những câu nói được ghi nhớ\n• Hầu như không thể giao tiếp nếu không dùng biểu cảm gương mặt hay ngôn ngữ cơ thể",
        band: 2,
      },
      {
        eComment:
          "• Resource limited to simple vocabulary used primarily to convey personal information.\n• Vocabulary inadequate for unfamiliar topics.",
        vComment:
          "• Học viên chỉ sử dụng được những từ vựng đơn giản để truyền đạt thông tin cá nhân\n• Học viên thiếu vốn từ để diễn đạt nhưng chủ đề ít quen thuộc hơn",
        band: 3,
      },
      {
        eComment:
          "• Resource sufficient for familiar topics but only basic meaning can be conveyed on unfamiliar topics.\n• Frequent inappropriacies and errors in word choice.\n• Rarely attempts paraphrase.",
        vComment:
          "• Học viên có vốn từ vựng đủ rộng về các chủ đề quen thuộc. Tuy nhiên, học viên chỉ có thể truyền đạt ý nghĩa cơ bản về các chủ đề không quen thuộc và thường xuyên mắc lỗi trong việc lựa chọn từ ngữ\n• Hiếm khi cố gắng thay đổi cách diễn đạt (paraphrase)",
        band: 4,
      },
      {
        eComment:
          "• Resource sufficient to discuss familiar and unfamiliar topics but there is limited flexibility.\n• Attempts paraphrase but not always with success.",
        vComment:
          "• Học viên có thể nói được về cả các chủ đề quen thuộc và không quen thuộc nhưng sử dụng từ vựng còn ít linh hoạt\n• Học viên có cố gắng sử dụng nhiều cách để diễn đạt nhưng thường không thành công",
        band: 5,
      },
      {
        eComment:
          "• Resource sufficient to discuss topics at length.\n• Vocabulary use may be inappropriate but meaning is clear.\n• Generally able to paraphrase successfully.",
        vComment:
          "• Học viên có vốn từ vựng đủ rộng để có những cuộc thảo luận dài về nhiều chủ đề\n• Học viên sử dụng từ vựng có thể không phù hợp những vẫn thể hiện ý nghĩa rõ ràng\n• Nhìn chung, học viên diễn đạt ý bằng nhiều cách chính xác",
        band: 6,
      },
      {
        eComment:
          "• Resource flexibly used to discuss a variety of topics.\n• Some ability to use less common and idiomatic items and an awareness of style and collocation is evident though inappropriacies occur.\n• Effective use of paraphrase as required.",
        vComment:
          "• Học viên sử dụng nguồn từ vựng một cách linh hoạt để thảo luận về nhiều chủ đề khác nhau\n• Học viên sử dụng được một số thành ngữ và các từ vựng ít phổ biến hơn, đồng thời cho thấy một số kiến thức về văn phong và cụm từ, tuy nhiên các sự lựa chọn chưa được phù hợp\n• Học viên sử dụng hiệu quả nhiều cách diễn đạt (paraphrase) khác nhau",
        band: 7,
      },
      {
        eComment:
          "• Wide resource, readily and flexibly used to discuss all topics and convey precise meaning.\n• Skilful use of less common and idiomatic items despite occasional inaccuracies in word choice and collocation.\n• Effective use of paraphrase as required.",
        vComment:
          "• Học viên sử dụng nguồn từ vựng phong phú và linh hoạt để truyền đạt ý nghĩa một cách chính xác đối với mọi chủ đề\n• Học viên sử dụng các từ vựng ít phổ biến và thành ngữ một cách khéo léo, chỉ đôi khi không chính xác trong cách dùng từ và collocation\n• Học viên sử dụng nhiều cách diễn đạt hiệu quả như được yêu cầu",
        band: 8,
      },
      {
        eComment:
          "• Total flexibility and precise use in all contexts.\n• Sustained use of accurate and idiomatic language.",
        vComment:
          "• Học viên sử dụng từ vựng một cách linh hoạt và chính xác trong tất cả các chủ đề\n• Học viên sử dụng các thành ngữ một cách tự nhiên và chính xác",
        band: 9,
      },
    ],
  },
  {
    vName: "Ngữ pháp và độ chính xác",
    eName: "Grammatical Range & Accuracy",
    apiName: "grammatical_range_accuracy",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment: "• No rateable language unless memorised.",
        vComment: "• Bài nói không đánh giá được ngoại trừ các câu thuộc lòng",
        band: 1,
      },
      {
        eComment: "• No evidence of basic sentence forms.",
        vComment: "• Học viên không thể hình thành các dạng câu cơ bản",
        band: 2,
      },
      {
        eComment:
          "• Basic sentence forms are attempted but grammatical errors are numerous except in apparently memorised utterances.",
        vComment:
          "• Học viên cố gắng sử dụng các dạng câu cơ bản nhưng có rất nhiều lỗi ngữ pháp ngoại trừ các câu nói có vẻ đã thuộc lòng",
        band: 3,
      },
      {
        eComment:
          "• Can produce basic sentence forms and some short utterances are error-free.\n• Subordinate clauses are rare and, overall, turns are short, structures are repetitive and errors are frequent.",
        vComment:
          "• Học viên hình thành được các dạng câu cơ bản và một số câu đơn giản đúng\n• Học viên hiếm khi sử dụng các mệnh đề phụ thuộc, nhìn chung, độ dài của các lượt nói ngắn, các cấu trúc lặp lại nhiều lần và thường mắc lỗi",
        band: 4,
      },
      {
        eComment:
          "• Basic sentence forms are fairly well controlled for accuracy.\n• Complex structures are attempted but these are limited in range, nearly always contain errors and may lead to the need for reformulation.",
        vComment:
          "• Học viên sử dụng các dạng câu cơ bản một cách hợp lý và chính xác\n• Học viên có sử dụng một số ít các cấu trúc phức tạp hơn, nhưng những cấu trúc này thường có lỗi và có thể gây ra một số vấn đề về việc hiểu",
        band: 5,
      },
      {
        eComment:
          "• Produces a mix of short and complex sentence forms and a variety of structures with limited flexibility.\n• Though errors frequently occur in complex structures, these rarely impede communication.",
        vComment:
          "• Học viên sử dụng kết hợp các câu ngắn và phức tạp và đa dạng các cấu trúc nhưng ít linh hoạt\n• Học viên có thể vẫn mắc lỗi thường xuyên với các cấu trúc phức tạp nhưng những lỗi này hiếm khi cản trở quá trình giao tiếp",
        band: 6,
      },
      {
        eComment:
          "• A range of structures flexibly used. Error-free sentences are frequent.\n• Both simple and complex sentences are used effectively despite some errors. A few basic errors persist.",
        vComment:
          "• Học viên sử dụng nhiều cấu trúc phức tạp một cách khá linh hoạt\n• Các câu thường không có lỗi, chỉ đôi khi còn một số lỗi ngữ pháp và sử dụng hiệu quả cả câu đơn và câu phức",
        band: 7,
      },
      {
        eComment:
          "• Wide range of structures, flexibly used.\n• The majority of sentences are error free.\n• Occasional inappropriacies and non-systematic errors occur. A few basic errors may persist.",
        vComment:
          "• Học viên sử dụng nhiều và đa dạng các loại cấu trúc một cách linh hoạt\n• Phần lớn các câu không có lỗi, chỉ thỉnh thoảng không phù hợp hoặc mắc các lỗi cơ bản/ lỗi không hệ thống",
        band: 8,
      },
      {
        eComment:
          "• Structures are precise and accurate at all times, apart from ‘mistakes’ characteristic of native speaker speech.",
        vComment:
          "• Cấu trúc các câu chính xác và nhất quán, loại trừ các “lỗi nhỏ”’ trong đặc điểm cách nói của người bản ngữ",
        band: 9,
      },
    ],
  },
  {
    vName: "Phát âm",
    eName: "Pronunciation",
    apiName: "pronunciation",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Can produce occasional individual words and phonemes that are recognisable, but no overall meaning is conveyed.\n• Unintelligible.",
        vComment:
          "• Đôi khi học viên có thể nói một số từ đơn và âm nhưng nhìn chung không có ý nghĩa\n• Bài nói hoàn toàn không thể hiểu được",
        band: 1,
      },
      {
        eComment:
          "• Uses few acceptable phonological features (possibly because sample is insufficient).\n• Overall problems with delivery impair attempts at connected speech.\n• Individual words and phonemes are mainly mispronounced and little meaning is conveyed.\n• Often unintelligible.",
        vComment:
          "• Vận dụng được rất ít các thành tố phát âm\n• Những vấn đề chung về cách truyền đạt ý tưởng ảnh hưởng đến sự cố gắng để nói liền mạch\n• Học viên phát âm sai hầu hết các từ đơn và âm, chỉ truyền đạt được một ít ý nghĩa của câu nói\n• Lời nói thường không thể hiểu được",
        band: 2,
      },
      {
        eComment:
          "• Displays some features of band 2, and some, but not all, of the positive features of band 4.",
        vComment:
          "• Thể hiện một số đặc điểm của Band 2 và một số, nhưng không phải tất cả các đặc điểm tích cực của Band 4",
        band: 3,
      },
      {
        eComment:
          "• Uses some acceptable phonological features, but the range is limited.\n• Produces some acceptable chunking, but there are frequent lapses in overall rhythm.\n• Attempts to use intonation and stress, but control is limited.\n• Individual words or phonemes are frequently mispronounced, causing lack of clarity.\n• Understanding requires some effort and there may be patches of speech that cannot be understood.",
        vComment:
          "• Học viên sử dụng được một số ngữ điệu và trọng âm nhưng khả năng kiểm soát còn hạn chế\n• Học viên liên kết được một số cụm từ nhưng nhịp điệu chung của bài nói có nhiều lỗi\n• Học viên phát âm sai các từ đơn và âm thường xuyên, khiến bài nói thiếu tính rõ ràng\n• Gây ra một số khó khăn cho người nghe, một số đoạn có thể không hiểu được",
        band: 4,
      },
      {
        eComment:
          "• Displays all the positive features of band 4, and some, but not all, of the positive features of band 6.",
        vComment:
          "• Thể hiện được tất cả các tính năng tích cực của Band 4 và một số, nhưng không phải tất cả các tính năng tích cực của Band 6",
        band: 5,
      },
      {
        eComment:
          "• Uses a range of phonological features, but control is variable.\n• Chunking is generally appropriate, but rhythm may be affected by a lack of stress-timing and/or a rapid speech rate.\n• Some effective use of intonation and stress, but this is not sustained.\n• Individual words or phonemes may be mispronounced but this causes only occasional lack of clarity.\n• Can generally be understood throughout without much effort.",
        vComment:
          "• Học viên sử dụng được một số các thành tố phát âm nhưng chưa kiểm soát tốt\n• Học viên liên kết các cụm từ một cách phù hợp, nhưng nhịp điệu nói có thể bị ảnh hưởng bởi cách đặt trọng âm và/hoặc tốc độ nói nhanh.\n• Học viên sử dụng hiệu quả một số ngữ điệu và trọng âm nhưng điều này không được duy trì xuyên suốt bài nói\n• Nhìn chung, bài nói có thể được hiểu xuyên suốt, mặc dù, việc phát âm sai các từ đơn hoặc âm đôi khi làm giảm độ rõ ràng",
        band: 6,
      },
      {
        eComment:
          "• Displays all the positive features of band 6, and some, but not all, of the positive features of band 8.",
        vComment:
          "• Thể hiện tất cả các tính năng tích cực của Band 6 và một số, nhưng không phải tất cả các tính năng tích cực của Band 8",
        band: 7,
      },
      {
        eComment:
          "• Uses a wide range of phonological features to convey precise and/or subtle meaning.\n• Can sustain appropriate rhythm. Flexible use of stress and intonation across long utterances, despite occasional lapses.\n• Can be easily understood throughout.\n• Accent has minimal effect on intelligibility.",
        vComment:
          "• Học viên sử dụng nhiều và đa dạng các thành tố phát âm với độ chính xác và sự tinh tế\n• Duy trì nhịp điệu phù hợp, sử dụng linh hoạt trọng âm và ngữ điệu trong các câu nói dài, chỉ thỉnh thoảng mắc lỗi\n• Xuyên suốt bài nói của học viên dễ hiểu\n• Ngữ điệu ảnh hưởng rất ít đến độ dễ hiểu của bài nói",
        band: 8,
      },
      {
        eComment:
          "• Uses a full range of phonological features to convey precise and/or subtle meaning.\n• Flexible use of features of connected speech is sustained throughout.\n• Can be effortlessly understood throughout.\n• Accent has no effect on intelligibility.",
        vComment:
          "• Học viên sử dụng đầy đủ các thành tố phát âm với độ chính xác và sự tinh tế\n• Học viên duy trì việc sử dụng linh hoạt các thành tố này xuyên suốt bài nói\n• Học viên có thể dễ dàng hiểu mà không cần nỗ lực\n• Ngữ điệu không ảnh hưởng đến độ dễ hiểu của bài nói",
        band: 9,
      },
    ],
  },
];

export const WritingCriteria = [
  {
    vName: "Trả lời nhiệm vụ",
    eName: "Task Response",
    apiName: "task_achievement_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the prompt.\n• Any copied rubric must be discounted.",
        vComment:
          "• Bài viết của học viên dưới 20 từ được chấm ở Band 1\n• Nội dung bài viết hoàn toàn không liên quan đến đề bài\n• Bất kỳ phần sao chép nào từ đề thì bài viết phải bị loại bỏ",
        band: 1,
      },
      {
        eComment:
          "• The content is barely related to the prompt.\n• No position can be identified.\n• There may be glimpses of one or two ideas without development.",
        vComment:
          "• Bài viết hầu như không đáp ứng được yêu cầu của đề bài \n• Bài viết không thể hiện được quan điểm \n• Có cố gắng trình bày một hoặc hai ý tưởng nhưng không biết cách phát triển những ý tưởng đó",
        band: 2,
      },
      {
        eComment:
          "• No part of the prompt is adequately addressed, or the prompt has been misunderstood.\n• No relevant position can be identified, and/or there is little direct response to the question/s.\n• There are few ideas, and these may be irrelevant or insufficiently developed.",
        vComment:
          "• Bài viết không thể hiện rõ ràng quan điểm \n• Trình bày rất ít ý tưởng, phần lớn trong số đó không được phát triển hoặc không liên quan đến chủ đề",
        band: 3,
      },
      {
        eComment:
          "• The prompt is tackled in a minimal way, or the answer is tangential, possibly due to some misunderstanding of the prompt. The format may be inappropriate.\n• A position is discernible, but the reader has to read carefully to find it.\n• Main ideas are difficult to identify and such ideas that are identifiable may lack relevance, clarity and/or support.\n• Large parts of the response may be repetitive.",
        vComment:
          "• Bài viết chỉ đáp ứng yêu cầu của đề bài một cách tối thiểu hoặc bị lạc đề/xa đề; định dạng bài viết có thể không phù hợp \n• Bài viết có trình bày quan điểm nhưng không rõ ràng\n• Bài viết trình bày được một số ý chính nhưng không rõ ràng, khó xác định và có thể lặp đi lặp lại, không liên quan hoặc không được hỗ trợ tốt",
        band: 4,
      },
      {
        eComment:
          "• The main parts of the prompt are incompletely addressed. The format may be inappropriate in places.\n• The writer expresses a position, but the development is not always clear.\n• Some main ideas are put forward, but they are limited and are not sufficiently developed and/or there may be irrelevant detail.\n• There may be some repetition.",
        vComment:
          "• Bài viết chỉ đáp ứng một phần yêu cầu đề bài; định dạng bài viết có thể không phù hợp ở một vài chỗ\n• Bài viết thể hiện được quan điểm của người viết nhưng cách phát triển bài không phải lúc nào cũng rõ ràng và có thể không có rút ra được kết luận. \n• Bài viết trình bày một số ý chính nhưng rất hạn chế và không phát triển đầy đủ; có thể chứa những chi tiết không liên quan",
        band: 5,
      },
      {
        eComment:
          "• The main parts of the prompt are addressed (though some may be more fully covered than others). An appropriate format is used.\n• A position is presented that is directly relevant to the prompt, although the conclusions drawn may be unclear, unjustified or repetitive.\n• Main ideas are relevant, but some may be insufficiently developed or may lack clarity, while some supporting arguments and evidence may be less relevant or inadequate.",
        vComment:
          "• Bài viết đáp ứng tất cả các yêu cầu của đề bài mặc dù một số phần có thể được triển khai đầy đủ hơn những phần khác \n• Bài viết trình bày quan điểm liên quan đến chủ đề dù các kết luận có thể không rõ ràng hoặc lặp đi lặp lại \n• Bài viết trình bày các ý chính liên quan nhưng một số có thể không được triển khai đủ sâu/không rõ ràng",
        band: 6,
      },
      {
        eComment:
          "• The main parts of the prompt are appropriately addressed.\n• A clear and developed position is presented.\n• Main ideas are extended and supported but there may be a tendency to over-generalise or there may be a lack of focus and precision in supporting ideas/material.",
        vComment:
          "• Bài viết  đáp ứng tất cả các yêu cầu của đề bài \n• Bài viết thể hiện quan điểm rõ ràng trong suốt bài viết\n• Bài viết trình bày, mở rộng và hỗ trợ các ý chính, nhưng có xu hướng mắc lỗi khái quát hóa quá mức và/hoặc các ý tưởng hỗ trợ có thể thiếu tập trung",
        band: 7,
      },
      {
        eComment:
          "• The prompt is appropriately and sufficiently addressed.\n• A clear and well-developed position is presented in response to the question/s.\n• Ideas are relevant, well extended and supported.\n• There may be occasional omissions or lapses in content.",
        vComment:
          "• Bài viết đáp ứng vừa đủ các yêu cầu của đề bài \n• Trình bày quan điểm rõ ràng, phát triển tốt và trực tiếp trả lời câu hỏi trong suốt bài làm\n• Trình bày, mở rộng và có hệ thống ý tưởng liên quan, mở rộng và làm rõ chủ đề\n• Bài viết có thể có một vài thiếu sót nhỏ trong nội dung",
        band: 8,
      },
      {
        eComment:
          "• The prompt is appropriately addressed and explored in depth.\n• A clear and fully developed position is presented which directly answers the question/s.\n• Ideas are relevant, fully extended and well supported.\n• Any lapses in content or support are extremely rare.",
        vComment:
          "• Bài viết đáp ứng được tất cả yêu cầu của đề bài \n• Bài viết trình bày rõ ràng quan điểm của người viết về chủ đề bằng hệ thống ý tưởng liên quan, mở rộng và hỗ trợ làm rõ chủ đề\n• Bài viết hầu như không có sai sót trong nội dung hoặc lập luận",
        band: 9,
      },
    ],
  },
  {
    vName: "Mạch lạc và liên kết",
    eName: "Coherence & Cohesion",
    apiName: "coherence_cohesion_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
        vComment:
          "• Bài viết dưới 20 từ được xếp ở Band 1\n• Bài viết không thể hiện được ý tưởng nào",
        band: 1,
      },
      {
        eComment:
          "• There is little relevant message, or the entire response may\nbe off-topic.\n• There is little evidence of control of organisational features.",
        vComment:
          "• Bài viết hầu như không sắp xếp được ý tưởng cho bài viết hoặc toàn bộ nội dung có thể lạc đề",
        band: 2,
      },
      {
        eComment:
          "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• There is minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.\n• Any attempts at paragraphing are unhelpful.",
        vComment:
          "• Bài viết chưa trình bày được ý tưởng một cách logic\n• Học viên có thể sử dụng một số lượng rất hạn chế các từ nối. Tuy nhiên các từ nối có thể chưa liên kết được mối quan hệ logic giữa các ý tưởng",
        band: 3,
      },
      {
        eComment:
          "• Information and ideas are evident but not arranged coherently and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.\n• There may be no paragraphing and/or no clear main topic within paragraphs.",
        vComment:
          "• Bài viết trình bày thông tin và ý tưởng nhưng chưa được sắp xếp một cách mạch lạc và không thể hiện được luận điểm trung tâm của bài một cách xuyên suốt\n• Sử dụng các công cụ liên kết đơn giản nhưng có thể không chính xác hoặc bị lặp từ\n• Các thông tin và ý tưởng có thể không viết được dưới dạng đoạn văn hoàn chỉnh",
        band: 4,
      },
      {
        eComment:
          "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.\n• Paragraphing may be inadequate or missing.",
        vComment:
          "• Bài viết trình bày thông tin với một số cách sắp xếp ý tưởng nhưng có thể thiếu diễn tiến tổng thể\n• Các từ nối chưa đầy đủ, chưa chính xác hoặc lạm dụng. \n• Có thể lặp đi lặp lại vì thiếu tham chiếu và thay thế\n• Có thể không viết thành đoạn văn, hoặc đoạn văn có thể không đầy đủ",
        band: 5,
      },
      {
        eComment:
          "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.\n• Paragraphing may not always be logical and/or the central topic may not always be clear.",
        vComment:
          "• Bài viết sắp xếp thông tin và ý tưởng một cách mạch lạc và có một diễn tiến tổng thể rõ ràng\n• Sử dụng các từ nối một cách hiệu quả, nhưng sự liên kết bên trong và/hoặc giữa các câu có thể bị lỗi hoặc máy móc hoá\n• Bài viết chưa có sự ổn định trong việc dùng phép dẫn chiếu một cách rõ ràng và hợp lý\n• Việc phân chia đoạn văn có thể chưa luôn hợp lý và/hoặc ý chính của đoạn có thể chưa được trình bày rõ ràng",
        band: 6,
      },
      {
        eComment:
          "• Information and ideas are logically organised, and there is a clear progression throughout the response. (A few lapses may occur, but these are minor.)\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.\n• Paragraphing is generally used effectively to support overall coherence, and the sequencing of ideas within a paragraph is generally logical.",
        vComment:
          "• Bài viết tổ chức thông tin và ý tưởng một cách logic; bài văn thể hiện được luận điểm trung tâm của bài một cách xuyên suốt (từ mở bài đến kết bài)\n• Sử dụng một loạt các công cụ liên kết một cách phù hợp mặc dù có đôi chỗ chưa tận dụng hoặc lạm dụng\n• Trong mỗi đoạn văn trình bày rõ một chủ đề trọng tâm",
        band: 7,
      },
      {
        eComment:
          "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence and cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
        vComment:
          "• Bài viết sắp xếp trình tự thông tin và ý tưởng một cách logic, khả năng liên kết được kiểm soát tốt\n• Đôi khi bài viết vẫn có thể xuất hiện sai sót nhỏ về tính mạch lạc và liên kết\n• Bài viết chia đoạn văn một cách hợp lý",
        band: 8,
      },
      {
        eComment:
          "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
        vComment:
          "• Bài viết sử dụng các công cụ liên kết một cách mượt mà và không gây ra sự chú ý \n• Bất kỳ sai sót nào của bài viết về mạch lạc hoặc liên kết đều ở mức tối thiểu\n• Bài viết chia đoạn văn một cách khéo léo",
        band: 9,
      },
    ],
  },
  {
    vName: "Vốn từ vựng (Writing)",
    eName: "Lexical Resource",
    apiName: "lexical_resource_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
        vComment:
          "• Bài viết dưới 20 từ được xếp ở Band 1\n• Bài viết chỉ có thể sử dụng một vài từ riêng lẻ",
        band: 1,
      },
      {
        eComment:
          "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
        vComment:
          "• Bài viết sử dụng một lượng từ vựng hạn chế\n• Bài viết không kiểm soát được các lỗi sai về cấu tạo từ và/hoặc chính tả",
        band: 2,
      },
      {
        eComment:
          "• The resource is inadequate (which may be due to the response being significantly underlength). Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
        vComment:
          "• Bài viết chỉ sử dụng rất ít từ vựng. Có thể quá phụ thuộc vào tài liệu hoặc ngôn ngữ học thuộc. \n• Khả năng chọn từ và/hoặc chính tả rất hạn chế, lỗi sai chiếm đa số và có thể làm sai nghĩa các ý",
        band: 3,
      },
      {
        eComment:
          "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
        vComment:
          "• Vốn từ hạn chế và không phù hợp hoặc không liên quan đến đề bài. \n• Bài viết sử dụng từ vựng ở mức cơ bản và những từ này có thể được sử dụng lặp đi lặp lại hoặc có thể không phù hợp với yêu cầu đề bài\n• Việc chọn từ không chính xác và/hoặc lỗi cấu tạo từ, chính tả có thể gây khó hiểu cho người đọc",
        band: 4,
      },
      {
        eComment:
          "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n• There may be frequent lapses in the appropriacy of word choice and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n• Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
        vComment:
          "• Bài viết sử dụng một lượng từ vựng hạn chế nhưng đủ để đáp ứng yêu cầu đề bài \n• Bài viết có thể dùng đúng một số từ vựng đơn giản nhưng không đa dạng, ít biến đổi cách diễn đạt. \n• Bài viết thường xuyên dùng từ không phù hợp, thể hiện sự thiếu linh hoạt qua việc đơn giản hóa/lặp lại nhiều. \n• Bài viết có thể mắc các lỗi chính tả và / hoặc trong cách cấu tạo từ gây ra một số khó khăn cho người đọc",
        band: 5,
      },
      {
        eComment:
          "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
        vComment:
          "• Bài viết sử dụng lượng từ vựng vừa đủ và phù hợp để đáp ứng yêu cầu đề bài\n• Học viên cố gắng sử dụng những từ vựng ít phổ biến hơn nhưng không có độ chính xác.  \n• Học viên có thể dùng từ đa dạng hơn nhưng một số chỗ có thể dễ sai hoặc không phù hợp.\n• Bài viết vẫn mắc một số lỗi về chính tả và /hoặc về cấu tạo từ, nhưng chúng không gây cản trở",
        band: 6,
      },
      {
        eComment:
          "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation and they do not detract from overall clarity.",
        vComment:
          "• Bài viết sử dụng lượng từ vựng để tạo sự linh hoạt và chính xác\n• Học viên có ý thức về phong cách và sự kết hợp từ, dù đôi khi chưa phù hợp. \n• Bài viết sử dụng các từ vựng ít phổ biến và/hoặc thành ngữ hơn nhưng đôi khi có thể mắc lỗi trong việc lựa chọn từ ngữ, chính tả và / hoặc cấu tạo từ",
        band: 7,
      },
      {
        eComment:
          "• A wide resource is fluently and flexibly used to convey precise meanings.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and collocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng lượng từ vựng lớn\n• Bài viết sử dụng các từ vựng ít phổ biến và/hoặc thành ngữ,  nhưng đôi khi có thể mắc lỗi trong việc lựa chọn từ ngữ hoặc sử dụng collocation\n• Bài viết mắc một số lỗi về chính tả hoặc cấu tạo từ",
        band: 8,
      },
      {
        eComment:
          "• Full flexibility and precise use are widely evident.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
        vComment:
          "• Sử dụng nhiều loại từ vựng một cách tự nhiên và linh hoạt để truyền đạt ý nghĩa chính xác và biết cách sử dụng các từ vựng phức tạp \n• Bài viết hiếm mắc lỗi chính tả/cấu tạo từ và gần như không ảnh hưởng đến giao tiếp.",
        band: 9,
      },
    ],
  },
  {
    vName: "Ngữ pháp (Writing)",
    eName: "Grammatical Range & Accuracy",
    apiName: "grammatical_range_accuracy_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\nNo rateable language is evident.",
        vComment:
          "• Bài viết dưới 20 từ được xếp ở Band 1\n• Bài viết hoàn toàn không thể viết thành câu",
        band: 1,
      },
      {
        eComment:
          "• There is little or no evidence of sentence forms (except in memorised phrases).",
        vComment:
          "• Bài viết không thể viết thành câu ngoại trừ những câu đã học thuộc lòng từ trước",
        band: 2,
      },
      {
        eComment:
          "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
        vComment:
          "• Học viên có cố gắng viết câu hoàn chỉnh, nhưng lỗi sai ngữ pháp và dấu câu khiến thông điệp bị bóp méo (ngoại trừ cụm từ học thuộc hoặc lấy từ đề bài)",
        band: 3,
      },
      {
        eComment:
          "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
        vComment:
          "• Bài viết chỉ sử dụng được một lượng rất hạn chế các cấu trúc và hiếm khi sử dụng được mệnh đề phụ thuộc\n• Một số cấu trúc được sử dụng chính xác tuy nhiên thường xuyên sai ngữ pháp và dấu câu",
        band: 4,
      },
      {
        eComment:
          "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
        vComment:
          "• Bài viết chỉ sử dụng một lượng hạn chế các cấu trúc\n• Học viên có cố gắng đặt những câu phức tạp nhưng những câu này sẽ không chính xác bằng các cấu trúc câu đơn\n• Bài viết thường xuyên mắc lỗi ngữ pháp và dấu câu có thể bị lỗi; lỗi có thể gây ra một số khó khăn cho người đọc",
        band: 5,
      },
      {
        eComment:
          "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication.",
        vComment:
          "• Bài viết kết hợp sử dụng cấu trúc đơn giản và phức tạp\n• Mắc một số lỗi ngữ pháp và dấu câu nhưng không ảnh hưởng tới truyền đạt thông tin",
        band: 6,
      },
      {
        eComment:
          "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
        vComment:
          "• Bài viết sử dụng nhiều cấu trúc phức tạp\n• Phần lớn các câu trong bài đều không mắc lỗi \n• Bài viết sử dụng đúng ngữ pháp và dấu câu nhưng có thể mắc một vài lỗi",
        band: 7,
      },
      {
        eComment:
          "• A wide range of structures is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng lượng lớn cấu trúc \n• Hầu hết các câu văn trong bài viết đều không mắc lỗi\n• Bài viết rất ít khi mắc lỗi hoặc sử dụng cấu trúc không phù hợp",
        band: 8,
      },
      {
        eComment:
          "• A wide range of structures is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng lượng lớn cấu trúc một cách tự nhiên và chính xác\n• Bài viết sử dụng dấu câu và ngữ pháp một cách phù hợp và chính xác trong toàn bài\n• Bài viết hiếm mắc lỗi ngữ pháp hầu như không ảnh hưởng đến khả năng truyền đạt",
        band: 9,
      },
    ],
  },
];
export const WritingCriteriaTaskOne = [
  {
    vName: "Trả lời nhiệm vụ",
    eName: "Task Response",
    apiName: "task_achievement_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the task.\n• Any copied rubric must be discounted.",
        vComment:
          "• Bài viết của học viên dưới 20 từ được chấm ở Band 1\n• Nội dung bài viết hoàn toàn không liên quan đến đề bài\n• Bất kỳ phần sao chép nào từ đề thì bài viết phải bị loại bỏ",
        band: 1,
      },
      {
        eComment: "• The content barely relates to the task.",
        vComment: "•  Bài viết hầu như không liên quan đến đề bài",
        band: 2,
      },
      {
        eComment:
          "• The response does not address the requirements of the task (possibly because of misunderstanding of the data/diagram/situation).\n• Key features/bullet points which are presented may be largely irrelevant.\n• Limited information is presented, and this may be used repetitively.",
        vComment:
          "• Bài viết không đáp ứng đúng yêu cầu, (có thể do hiểu sai dữ liệu/biểu đồ/tình huống)\n• Ý tưởng của bài viết phần lớn không liên quan \n• Thông tin của bài viết đưa ra còn hạn chế, có thể lặp lại",
        band: 3,
      },
      {
        eComment:
          "• The response is an attempt to address the task.\n• Few key features have been selected.\n• The format may be inappropriate.\n• Key features/bullet points which are presented may be irrelevant, repetitive, inaccurate or inappropriate.",
        vComment:
          "• Học viên có thể hoàn thành bài viết, nhưng các câu trả lời bị lạc đề \n• Các ý chính được trình bày có thể không liên quan, lặp lại, thiếu chính xác hoặc không phù hợp",
        band: 4,
      },
      {
        eComment:
          "• The response generally addresses the requirements of the task. The format may be inappropriate in places.\n• Key features which are selected are not adequately covered. The recounting of detail is mainly mechanical. There may be no data to support the description.\n• There may be a tendency to focus on details (without referring to the bigger picture).\n• The inclusion of irrelevant, inappropriate or inaccurate material in key areas detracts from the task achievement.\n• There is limited detail when extending and illustrating the main points.",
        vComment:
          "• Học viên cố gắng hoàn thành yêu cầu nhưng không bao quát tất cả các ý chính/gạch đầu dòng chính; cấu trúc bài viết có thể không phù hợp\n• Bài viết thường chỉ liệt kê số liệu, thiếu phân tích, có thể không dùng số liệu minh chứng\n• Bài viết có thông tin thừa, sai hoặc không liên quan, các ý chính chưa được mở rộng hay minh họa tốt",
        band: 5,
      },
      {
        eComment:
          "• The response focuses on the requirements of the task and an appropriate format is used.\n• Key features which are selected are covered and adequately highlighted. A relevant overview is attempted. Information is appropriately selected and supported using figures/data.\n• Some irrelevant, inappropriate or inaccurate information may occur in areas of detail or when illustrating or extending the main points.\n• Some details may be missing (or excessive) and further extension or illustration may be needed.",
        vComment:
          "• Nhìn chung, bài viết đã đáp ứng yêu cầu cơ bản của đề bài; cấu trúc có thể không phù hợp ở một số đoạn\n• Bài viết miêu tả lại chi tiết một cách máy móc mà không có cái nhìn tổng quan rõ ràng; có thể không có dữ liệu để hỗ trợ cho phần miêu tả\n• Nội dung thường chỉ tập trung vào các ý chính mà thiếu đi sự chi tiết hoặc minh họa",
        band: 6,
      },
      {
        eComment:
          "• The response covers the requirements of the task.\n• The content is relevant and accurate – there may be a few omissions or lapses. The format is appropriate.\n• Key features which are selected are covered and clearly highlighted but could be more fully or more appropriately illustrated or extended.\n• It presents a clear overview, the data are appropriately categorised, and main trends or differences are identified.",
        vComment:
          "• Bài viết đáp ứng được yêu cầu của đề bài với một số thiếu sót nhỏ\n• Bài viết trình bày tổng quan với thông tin được lựa chọn phù hợp\n• Các đặc điểm chính được chọn và làm nổi bật rõ ràng, mặc dù có thể cần bổ sung hoặc minh họa thêm.",
        band: 7,
      },
      {
        eComment:
          "• The response covers all the requirements of the task appropriately, relevantly and sufficiently.\n• Key features are skilfully selected, and clearly presented, highlighted and illustrated.\n• There may be occasional omissions or lapses in content.",
        vComment:
          "• Bài viết thực hiện đúng yêu cầu của đề bài, có thể có một vài thiếu sót nhỏ\n• Bài viết chọn lọc đặc điểm chính rất tốt, trình bày rõ ràng, minh họa hợp lý\n• Bài viết có thể còn vài thiếu sót nhỏ nhưng không đáng kể",
        band: 8,
      },
      {
        eComment:
          "• All the requirements of the task are fully and appropriately satisfied.\n• There may be extremely rare lapses in content.",
        vComment:
          "• Bài viết đáp ứng đầy đủ và chính xác tất cả yêu cầu đề bài\n• Nội dung hoàn chỉnh, không có bất kỳ thiếu sót nào, và mọi thông tin đều được trình bày chi tiết, phù hợp",
        band: 9,
      },
    ],
  },
  {
    vName: "Mạch lạc và liên kết",
    eName: "Coherence & Cohesion",
    apiName: "coherence_cohesion_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
        vComment:
          "• Bài viết của học viên dưới 20 từ được chấm ở Band 1\n• Không có sự tổ chức nào trong bài viết, không có gắn kết giữa các câu",
        band: 1,
      },
      {
        eComment:
          "• There is little relevant message, or the entire response may be off-topic.\n• There is little evidence of control of organisational features.",
        vComment:
          "• Bài viết hầu như không sắp xếp được ý tưởng cho bài viết hoặc toàn bộ nội dung có thể lạc đề",
        band: 2,
      },
      {
        eComment:
          "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• Minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.",
        vComment:
          "• Bài viết không có tổ chức logic, ý có nhưng khó nối kết với nhau\n• Bài viết sử dụng rất hạn chế các liên kết và các từ nối và những từ được sử dụng có thể chưa chỉ ra được mối quan hệ logic giữa các ý tưởng",
        band: 3,
      },
      {
        eComment:
          "• Information and ideas are evident but not arranged coherently, and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.",
        vComment:
          "• Bài viết đã trình bày được các thông tin và ý tưởng. Tuy nhiên, các ý tưởng được sắp xếp chưa mạch lạc và không có sự phát triển rõ ràng trong câu trả lời\n• Sử dụng một số từ nối cơ bản nhưng những từ này có thể không chính xác hoặc lặp đi lặp lại",
        band: 4,
      },
      {
        eComment:
          "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.",
        vComment:
          "• Bài viết trình bày thông tin với một trật tự nhất định nhưng tổng thể chưa phù hợp\n• Các từ nối sử dụng trong bài chưa đầy đủ, không chính xác hoặc lạm dụng\n• Bài viết có thể lặp đi lặp lại vì thiếu tham chiếu và các từ thay thế",
        band: 5,
      },
      {
        eComment:
          "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.",
        vComment:
          "• Bài viết sắp xếp thông tin và ý tưởng một cách mạch lạc và có một tiến trình tổng thể rõ ràng\n• Sử dụng các từ nối một cách hiệu quả, nhưng sự liên kết bên trong và/hoặc giữa các câu có thể bị lỗi hoặc máy móc hoá\n• Việc dùng từ tham chiếu và từ thay thế chưa linh hoạt hoặc chưa rõ ràng, dẫn đến lặp từ hoặc mắc lỗi",
        band: 6,
      },
      {
        eComment:
          "• Information and ideas are logically organised and there is a clear progression throughout the response. A few lapses may occur.\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.",
        vComment:
          "• Bài viết sắp xếp thông tin và ý tưởng một cách hợp lý; có sự tiến bộ rõ ràng trong suốt bài, nhưng vẫn có thể có một vài thiếu sót về sự gắn kết\n• Bài viết sử dụng một loạt các từ nối tương đối linh hoạt tuy nhiên có thể có vài lỗi nhỏ trong cách dùng hoặc sắp xếp",
        band: 7,
      },
      {
        eComment:
          "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence or cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
        vComment:
          "• Bài viết trình bày các thông tin và ý tưởng một cách hợp lý\n• Việc sử dụng từ nối và phân đoạn phù hợp, mặc dù đôi khi có thể có những thiếu sót nhỏ",
        band: 8,
      },
      {
        eComment:
          "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
        vComment:
          "• Các ý tưởng của bài viết được sắp xếp và liên kết một cách tự nhiên, rõ ràng và dễ theo dõi. \n• Phần chia đoạn và các từ nối được sử dụng một cách tinh tế, không làm phân tán sự chú ý của người đọc",
        band: 9,
      },
    ],
  },
  {
    vName: "Vốn từ vựng (Writing)",
    eName: "Lexical Resource",
    apiName: "lexical_resource_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
        vComment:
          "• Bài viết của học viên dưới 20 từ được chấm ở Band 1\n• Không có vốn từ cần thiết để diễn đạt ý tưởng, chỉ vài từ đơn lẻ hoặc lỗi nặng về từ vựng",
        band: 1,
      },
      {
        eComment:
          "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
        vComment:
          "• Bài viết sử dụng một lượng từ vựng rất hạn chế; về cơ bản chưa kiểm soát được các lỗi sai về cấu tạo từ và/hoặc chính tả",
        band: 2,
      },
      {
        eComment:
          "• The resource is inadequate (which may be due to the response being significantly underlength).\n• Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
        vComment:
          "• Bài viết chỉ sử dụng một phạm vi từ nhất định, phụ thuộc nhiều vào từ đã học thuộc  \n• Một số lỗi trong bài viết có thể làm thay đổi về mặt ngữ nghĩa \n• Cách diễn đạt còn rất hạn chế với khả năng kiểm soát rất hạn chế về cấu tạo từ và/hoặc chính tả",
        band: 3,
      },
      {
        eComment:
          "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
        vComment:
          "• Bài viết chỉ sử dụng từ vựng hạn chế, đơn giản, thường sử dụng lặp lại hoặc có thể không phù hợp với đề bài\n• Bài viết có thể dùng sai cụm từ \n• Các lỗi từ vựng có thể gây khó khăn trong việc hiểu",
        band: 4,
      },
      {
        eComment:
          "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n•  There may be frequent lapses in the appropriacy of word choice, and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n•  Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
        vComment:
          "• Bài viết chỉ sử dụng từ vựng hạn chế, nhưng các từ vựng này phù hợp với chủ đề\n• Bài viết có thể dùng từ vựng đơn giản khá chính xác nhưng ít đa dạng, cách diễn đạt lặp lại\n• Bài viết thường chọn từ chưa phù hợp, thiếu linh hoạt, hay lặp lại hoặc viết quá đơn giản \n• Lỗi từ vựng có thể ảnh hưởng đến khả năng hiểu nội dung",
        band: 5,
      },
      {
        eComment:
          "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
        vComment:
          "• Bài viết sử dụng đủ lượng từ vựng cho chủ đề\n• Cố gắng sử dụng từ vựng ít phổ biến hơn nhưng có một số từ sử dụng thiếu sự linh hoạt và chính xác \n• Mắc một số lỗi chính tả và/hoặc cấu tạo từ, nhưng ảnh hưởng lớn đến nội dung",
        band: 6,
      },
      {
        eComment:
          "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation, and they do not detract from overall clarity.",
        vComment:
          "• Bài viết sử dụng vốn từ vựng đủ rộng để diễn đạt ý tưởng một cách linh hoạt và chính xác\n• Sử dụng các mục từ vựng ít phổ biến hơn, nắm được về văn phong và collocation \n• Thỉnh thoảng có thể mắc lỗi trong việc lựa chọn từ, chính tả và/hoặc cấu tạo từ",
        band: 7,
      },
      {
        eComment:
          "• A wide resource is fluently and flexibly used to convey precise meanings within the scope of the task.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and\ncollocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng vốn từ vựng phong phú, một cách trôi chảy và linh hoạt, truyền đạt ý nghĩa một cách chính xác\n• Học viên khéo léo sử dụng các từ vựng không phổ biến nhưng đôi khi có thể không chính xác trong việc lựa chọn từ và kết hợp từ phù hợp\n• Bài viết thỉnh thoảng mắc các lỗi hiếm gặp về chính tả và/hoặc cấu tạo từ",
        band: 8,
      },
      {
        eComment:
          "• Full flexibility and precise use are evident within the scope of the task.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng một lượng từ vựng phong phú với độ chính xác và tự nhiên cao\n• Bài viết có các lỗi nhỏ về chính tả hoặc cấu trúc từ rất hiếm gặp và không ảnh hưởng đến nội dung",
        band: 9,
      },
    ],
  },
  {
    vName: "Ngữ pháp (Writing)",
    eName: "Grammatical Range & Accuracy",
    apiName: "grammatical_range_accuracy_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• No rateable language is evident.",
        vComment:
          "• Bài viết của học viên dưới 20 từ được chấm ở Band 1\n• Không có cấu trúc câu rõ ràng, nhiều lỗi ngữ pháp làm mất hoàn toàn ý nghĩa của bài viết",
        band: 1,
      },
      {
        eComment:
          "• There is little or no evidence of sentence forms (except in memorised phrases).",
        vComment:
          "• Bài viết chưa sử dụng được các mẫu câu ngoại trừ trong các cụm từ được ghi nhớ",
        band: 2,
      },
      {
        eComment:
          "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
        vComment:
          "• Học viên đã cố gắng đặt câu nhưng lỗi ngữ pháp và dấu câu chiếm còn nhiều và làm cho bài viết khó hiểu\n• Bài viết có thể quá ngắn nên chưa thể hiện được khả năng sử dụng và kiểm soát cấu trúc câu",
        band: 3,
      },
      {
        eComment:
          "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
        vComment:
          "• Bài viết chỉ sử dụng cấu trúc câu hạn chế và các câu phức hiếm khi chính xác\n• Một số cấu trúc được sử dụng chính xác nhưng vẫn còn tồn tại nhiều lỗi ngữ pháp ảnh hưởng đến nội dung\n• Bài viết sử dụng dấu câu thường sai hoặc chưa đầy đủ",
        band: 4,
      },
      {
        eComment:
          "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
        vComment:
          "• Bài viết chỉ sử dụng một số cấu trúc hạn chế\n• Học viên cố gắng đặt những câu phức tạp nhưng những câu này có xu hướng kém chính xác hơn những câu đơn giản\n• Bài viết có thể mắc lỗi ngữ pháp phổ biến và dấu câu có thể bị lỗi; lỗi có thể gây ra một số khó khăn trong việc hiểu nội dung",
        band: 5,
      },
      {
        eComment:
          "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication",
        vComment:
          "• Bài viết sử dụng kết hợp các câu đơn giản và câu phức một cách hợp lý, nhưng có thể hạn chế trong sự linh hoạt và độ chính xác\n• Lỗi ngữ pháp và dấu câu có thể thường xuyên hơn nhưng hiếm làm cản trở nội dung",
        band: 6,
      },
      {
        eComment:
          "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
        vComment:
          "• Bài viết sử dụng nhiều loại câu phức với mức độ linh hoạt và chính xác nhất định\n• Ngữ pháp và dấu câu nhìn chung được kiểm soát tốt, nhiều câu hoàn toàn không có lỗi\n• Một vài lỗi nhỏ có thể xuất hiện nhưng không ảnh hưởng lớn đến nội dung",
        band: 7,
      },
      {
        eComment:
          "• A wide range of structures within the scope of the task is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
        vComment:
          "• Học viên sử dụng phạm vi cấu trúc ngữ pháp rộng, các câu phức được sử dụng chính xác và tự nhiên\n• Phần lớn các câu không có lỗi, dấu câu được dùng hợp lý\n• Một vài lỗi nhỏ có thể xuất hiện nhưng không gây khó khăn cho người đọc",
        band: 8,
      },
      {
        eComment:
          "• A wide range of structures within the scope of the task is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication",
        vComment:
          "• Học viên sử dụng linh hoạt và kiểm soát hoàn toàn các cấu trúc ngữ pháp phức tạp và dấu câu\n• Ngữ pháp và dấu câu được dùng chuẩn xác xuyên suốt bài viết\n• Các lỗi ngữ pháp hiếm khi xuất hiện và không làm ảnh hưởng đến nội dung",
        band: 9,
      },
    ],
  },
];
export const WritingCriteriaTaskTwo = [
  {
    vName: "Trả lời nhiệm vụ",
    eName: "Task Response",
    apiName: "task_achievement_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• The content is wholly unrelated to the prompt.\n• Any copied rubric must be discounted.",
        vComment:
          "• Bài viết của học viên dưới 20 từ được chấm ở Band 1\n• Nội dung bài viết hoàn toàn không liên quan đến đề bài\n• Bất kỳ phần sao chép nào từ đề thì bài viết phải bị loại bỏ",
        band: 1,
      },
      {
        eComment:
          "• The content is barely related to the prompt.\n• No position can be identified.\n• There may be glimpses of one or two ideas without development.",
        vComment:
          "• Bài viết hầu như không đáp ứng được yêu cầu của đề bài \n• Bài viết không thể hiện được quan điểm \n• Có cố gắng trình bày một hoặc hai ý tưởng nhưng không biết cách phát triển những ý tưởng đó",
        band: 2,
      },
      {
        eComment:
          "• No part of the prompt is adequately addressed, or the prompt has been misunderstood.\n• No relevant position can be identified, and/or there is little direct response to the question/s.\n• There are few ideas, and these may be irrelevant or insufficiently developed.",
        vComment:
          "• Bài viết không thể hiện rõ ràng quan điểm \n• Trình bày rất ít ý tưởng, phần lớn trong số đó không được phát triển hoặc không liên quan đến chủ đề",
        band: 3,
      },
      {
        eComment:
          "• The prompt is tackled in a minimal way, or the answer is tangential, possibly due to some misunderstanding of the prompt. The format may be inappropriate.\n• A position is discernible, but the reader has to read carefully to find it.\n• Main ideas are difficult to identify and such ideas that are identifiable may lack relevance, clarity and/or support.\n• Large parts of the response may be repetitive.",
        vComment:
          "• Bài viết chỉ đáp ứng yêu cầu của đề bài một cách tối thiểu hoặc bị lạc đề/xa đề; định dạng bài viết có thể không phù hợp \n• Bài viết có trình bày quan điểm nhưng không rõ ràng\n• Bài viết trình bày được một số ý chính nhưng không rõ ràng, khó xác định và có thể lặp đi lặp lại, không liên quan hoặc không được hỗ trợ tốt",
        band: 4,
      },
      {
        eComment:
          "• The main parts of the prompt are incompletely addressed. The format may be inappropriate in places.\n• The writer expresses a position, but the development is not always clear.\n• Some main ideas are put forward, but they are limited and are not sufficiently developed and/or there may be irrelevant detail.\n• There may be some repetition.",
        vComment:
          "• Bài viết chỉ đáp ứng một phần yêu cầu đề bài; định dạng bài viết có thể không phù hợp ở một vài chỗ\n• Bài viết thể hiện được quan điểm của người viết nhưng cách phát triển bài không phải lúc nào cũng rõ ràng và có thể không có rút ra được kết luận. \n• Bài viết trình bày một số ý chính nhưng rất hạn chế và không phát triển đầy đủ; có thể chứa những chi tiết không liên quan",
        band: 5,
      },
      {
        eComment:
          "• The main parts of the prompt are addressed (though some may be more fully covered than others). An appropriate format is used.\n• A position is presented that is directly relevant to the prompt, although the conclusions drawn may be unclear, unjustified or repetitive.\n• Main ideas are relevant, but some may be insufficiently developed or may lack clarity, while some supporting arguments and evidence may be less relevant or inadequate.",
        vComment:
          "• Bài viết đáp ứng tất cả các yêu cầu của đề bài mặc dù một số phần có thể được triển khai đầy đủ hơn những phần khác \n• Bài viết trình bày quan điểm liên quan đến chủ đề dù các kết luận có thể không rõ ràng hoặc lặp đi lặp lại \n• Bài viết trình bày các ý chính liên quan nhưng một số có thể không được triển khai đủ sâu/không rõ ràng",
        band: 6,
      },
      {
        eComment:
          "• The main parts of the prompt are appropriately addressed.\n• A clear and developed position is presented.\n• Main ideas are extended and supported but there may be a tendency to over-generalise or there may be a lack of focus and precision in supporting ideas/material.",
        vComment:
          "• Bài viết  đáp ứng tất cả các yêu cầu của đề bài \n• Bài viết thể hiện quan điểm rõ ràng trong suốt bài viết\n• Bài viết trình bày, mở rộng và hỗ trợ các ý chính, nhưng có xu hướng mắc lỗi khái quát hóa quá mức và/hoặc các ý tưởng hỗ trợ có thể thiếu tập trung",
        band: 7,
      },
      {
        eComment:
          "• The prompt is appropriately and sufficiently addressed.\n• A clear and well-developed position is presented in response to the question/s.\n• Ideas are relevant, well extended and supported.\n• There may be occasional omissions or lapses in content.",
        vComment:
          "• Bài viết đáp ứng vừa đủ các yêu cầu của đề bài \n• Trình bày quan điểm rõ ràng, phát triển tốt và trực tiếp trả lời câu hỏi trong suốt bài làm\n• Trình bày, mở rộng và có hệ thống ý tưởng liên quan, mở rộng và làm rõ chủ đề\n• Bài viết có thể có một vài thiếu sót nhỏ trong nội dung",
        band: 8,
      },
      {
        eComment:
          "• The prompt is appropriately addressed and explored in depth.\n• A clear and fully developed position is presented which directly answers the question/s.\n• Ideas are relevant, fully extended and well supported.\n• Any lapses in content or support are extremely rare.",
        vComment:
          "• Bài viết đáp ứng được tất cả yêu cầu của đề bài \n• Bài viết trình bày rõ ràng quan điểm của người viết về chủ đề bằng hệ thống ý tưởng liên quan, mở rộng và hỗ trợ làm rõ chủ đề\n• Bài viết hầu như không có sai sót trong nội dung hoặc lập luận",
        band: 9,
      },
    ],
  },
  {
    vName: "Mạch lạc và liên kết",
    eName: "Coherence & Cohesion",
    apiName: "coherence_cohesion_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• The writing fails to communicate any message and appears to be by a virtual non-writer.",
        vComment:
          "• Bài viết dưới 20 từ được xếp ở Band 1\n• Bài viết không thể hiện được ý tưởng nào",
        band: 1,
      },
      {
        eComment:
          "• There is little relevant message, or the entire response may\nbe off-topic.\n• There is little evidence of control of organisational features.",
        vComment:
          "• Bài viết hầu như không sắp xếp được ý tưởng cho bài viết hoặc toàn bộ nội dung có thể lạc đề",
        band: 2,
      },
      {
        eComment:
          "• There is no apparent logical organisation. Ideas are discernible but difficult to relate to each other.\n• There is minimal use of sequencers or cohesive devices. Those used do not necessarily indicate a logical relationship between ideas.\n• There is difficulty in identifying referencing.\n• Any attempts at paragraphing are unhelpful.",
        vComment:
          "• Bài viết chưa trình bày được ý tưởng một cách logic\n• Học viên có thể sử dụng một số lượng rất hạn chế các từ nối. Tuy nhiên các từ nối có thể chưa liên kết được mối quan hệ logic giữa các ý tưởng",
        band: 3,
      },
      {
        eComment:
          "• Information and ideas are evident but not arranged coherently and there is no clear progression within the response.\n• Relationships between ideas can be unclear and/or inadequately marked. There is some use of basic cohesive devices, which may be inaccurate or repetitive.\n• There is inaccurate use or a lack of substitution or referencing.\n• There may be no paragraphing and/or no clear main topic within paragraphs.",
        vComment:
          "• Bài viết trình bày thông tin và ý tưởng nhưng chưa được sắp xếp một cách mạch lạc và không thể hiện được luận điểm trung tâm của bài một cách xuyên suốt\n• Sử dụng các công cụ liên kết đơn giản nhưng có thể không chính xác hoặc bị lặp từ\n• Các thông tin và ý tưởng có thể không viết được dưới dạng đoạn văn hoàn chỉnh",
        band: 4,
      },
      {
        eComment:
          "• Organisation is evident but is not wholly logical and there may be a lack of overall progression. Nevertheless, there is a sense of underlying coherence to the response.\n• The relationship of ideas can be followed but the sentences are not fluently linked to each other.\n• There may be limited/overuse of cohesive devices with some inaccuracy.\n• The writing may be repetitive due to inadequate and/or inaccurate use of reference and substitution.\n• Paragraphing may be inadequate or missing.",
        vComment:
          "• Bài viết trình bày thông tin với một số cách sắp xếp ý tưởng nhưng có thể thiếu diễn tiến tổng thể\n• Các từ nối chưa đầy đủ, chưa chính xác hoặc lạm dụng. \n• Có thể lặp đi lặp lại vì thiếu tham chiếu và thay thế\n• Có thể không viết thành đoạn văn, hoặc đoạn văn có thể không đầy đủ",
        band: 5,
      },
      {
        eComment:
          "• Information and ideas are generally arranged coherently and there is a clear overall progression.\n• Cohesive devices are used to some good effect but cohesion within and/or between sentences may be faulty or mechanical due to misuse, overuse or omission.\n• The use of reference and substitution may lack flexibility or clarity and result in some repetition or error.\n• Paragraphing may not always be logical and/or the central topic may not always be clear.",
        vComment:
          "• Bài viết sắp xếp thông tin và ý tưởng một cách mạch lạc và có một diễn tiến tổng thể rõ ràng\n• Sử dụng các từ nối một cách hiệu quả, nhưng sự liên kết bên trong và/hoặc giữa các câu có thể bị lỗi hoặc máy móc hoá\n• Bài viết chưa có sự ổn định trong việc dùng phép dẫn chiếu một cách rõ ràng và hợp lý\n• Việc phân chia đoạn văn có thể chưa luôn hợp lý và/hoặc ý chính của đoạn có thể chưa được trình bày rõ ràng",
        band: 6,
      },
      {
        eComment:
          "• Information and ideas are logically organised, and there is a clear progression throughout the response. (A few lapses may occur, but these are minor.)\n• A range of cohesive devices including reference and substitution is used flexibly but with some inaccuracies or some over/under use.\n• Paragraphing is generally used effectively to support overall coherence, and the sequencing of ideas within a paragraph is generally logical.",
        vComment:
          "• Bài viết tổ chức thông tin và ý tưởng một cách logic; bài văn thể hiện được luận điểm trung tâm của bài một cách xuyên suốt (từ mở bài đến kết bài)\n• Sử dụng một loạt các công cụ liên kết một cách phù hợp mặc dù có đôi chỗ chưa tận dụng hoặc lạm dụng\n• Trong mỗi đoạn văn trình bày rõ một chủ đề trọng tâm",
        band: 7,
      },
      {
        eComment:
          "• The message can be followed with ease.\n• Information and ideas are logically sequenced, and cohesion is well managed.\n• Occasional lapses in coherence and cohesion may occur.\n• Paragraphing is used sufficiently and appropriately.",
        vComment:
          "• Bài viết sắp xếp trình tự thông tin và ý tưởng một cách logic, khả năng liên kết được kiểm soát tốt\n• Đôi khi bài viết vẫn có thể xuất hiện sai sót nhỏ về tính mạch lạc và liên kết\n• Bài viết chia đoạn văn một cách hợp lý",
        band: 8,
      },
      {
        eComment:
          "• The message can be followed effortlessly.\n• Cohesion is used in such a way that it very rarely attracts attention.\n• Any lapses in coherence or cohesion are minimal.\n• Paragraphing is skilfully managed.",
        vComment:
          "• Bài viết sử dụng các công cụ liên kết một cách mượt mà và không gây ra sự chú ý \n• Bất kỳ sai sót nào của bài viết về mạch lạc hoặc liên kết đều ở mức tối thiểu\n• Bài viết chia đoạn văn một cách khéo léo",
        band: 9,
      },
    ],
  },
  {
    vName: "Vốn từ vựng (Writing)",
    eName: "Lexical Resource",
    apiName: "lexical_resource_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\n• No resource is apparent, except for a few isolated words.",
        vComment:
          "• Bài viết dưới 20 từ được xếp ở Band 1\n• Bài viết chỉ có thể sử dụng một vài từ riêng lẻ",
        band: 1,
      },
      {
        eComment:
          "• The resource is extremely limited with few recognisable strings, apart from memorised phrases.\n• There is no apparent control of word formation and/or spelling.",
        vComment:
          "• Bài viết sử dụng một lượng từ vựng hạn chế\n• Bài viết không kiểm soát được các lỗi sai về cấu tạo từ và/hoặc chính tả",
        band: 2,
      },
      {
        eComment:
          "• The resource is inadequate (which may be due to the response being significantly underlength). Possible over-dependence on input material or memorised language.\n• Control of word choice and/or spelling is very limited, and errors predominate. These errors may severely impede meaning.",
        vComment:
          "• Bài viết chỉ sử dụng rất ít từ vựng. Có thể quá phụ thuộc vào tài liệu hoặc ngôn ngữ học thuộc. \n• Khả năng chọn từ và/hoặc chính tả rất hạn chế, lỗi sai chiếm đa số và có thể làm sai nghĩa các ý",
        band: 3,
      },
      {
        eComment:
          "• The resource is limited and inadequate for or unrelated to the task. Vocabulary is basic and may be used repetitively.\n• There may be inappropriate use of lexical chunks (e.g. memorised phrases, formulaic language and/or language from the input material).\n• Inappropriate word choice and/or errors in word formation and/or in spelling may impede meaning.",
        vComment:
          "• Vốn từ hạn chế và không phù hợp hoặc không liên quan đến đề bài. \n• Bài viết sử dụng từ vựng ở mức cơ bản và những từ này có thể được sử dụng lặp đi lặp lại hoặc có thể không phù hợp với yêu cầu đề bài\n• Việc chọn từ không chính xác và/hoặc lỗi cấu tạo từ, chính tả có thể gây khó hiểu cho người đọc",
        band: 4,
      },
      {
        eComment:
          "• The resource is limited but minimally adequate for the task.\n• Simple vocabulary may be used accurately but the range does not permit much variation in expression.\n• There may be frequent lapses in the appropriacy of word choice and a lack of flexibility is apparent in frequent simplifications and/or repetitions.\n• Errors in spelling and/or word formation may be noticeable and may cause some difficulty for the reader.",
        vComment:
          "• Bài viết sử dụng một lượng từ vựng hạn chế nhưng đủ để đáp ứng yêu cầu đề bài \n• Bài viết có thể dùng đúng một số từ vựng đơn giản nhưng không đa dạng, ít biến đổi cách diễn đạt. \n• Bài viết thường xuyên dùng từ không phù hợp, thể hiện sự thiếu linh hoạt qua việc đơn giản hóa/lặp lại nhiều. \n• Bài viết có thể mắc các lỗi chính tả và / hoặc trong cách cấu tạo từ gây ra một số khó khăn cho người đọc",
        band: 5,
      },
      {
        eComment:
          "• The resource is generally adequate and appropriate for the task.\n• The meaning is generally clear in spite of a rather restricted range or a lack of precision in word choice.\n• If the writer is a risk-taker, there will be a wider range of vocabulary used but higher degrees of inaccuracy or inappropriacy.\n• There are some errors in spelling and/or word formation, but these do not impede communication.",
        vComment:
          "• Bài viết sử dụng lượng từ vựng vừa đủ và phù hợp để đáp ứng yêu cầu đề bài\n• Học viên cố gắng sử dụng những từ vựng ít phổ biến hơn nhưng không có độ chính xác.  \n• Học viên có thể dùng từ đa dạng hơn nhưng một số chỗ có thể dễ sai hoặc không phù hợp.\n• Bài viết vẫn mắc một số lỗi về chính tả và /hoặc về cấu tạo từ, nhưng chúng không gây cản trở",
        band: 6,
      },
      {
        eComment:
          "• The resource is sufficient to allow some flexibility and precision.\n• There is some ability to use less common and/or idiomatic items.\n• An awareness of style and collocation is evident, though inappropriacies occur.\n• There are only a few errors in spelling and/or word formation and they do not detract from overall clarity.",
        vComment:
          "• Bài viết sử dụng lượng từ vựng để tạo sự linh hoạt và chính xác\n• Học viên có ý thức về phong cách và sự kết hợp từ, dù đôi khi chưa phù hợp. \n• Bài viết sử dụng các từ vựng ít phổ biến và/hoặc thành ngữ hơn nhưng đôi khi có thể mắc lỗi trong việc lựa chọn từ ngữ, chính tả và / hoặc cấu tạo từ",
        band: 7,
      },
      {
        eComment:
          "• A wide resource is fluently and flexibly used to convey precise meanings.\n• There is skilful use of uncommon and/or idiomatic items when appropriate, despite occasional inaccuracies in word choice and collocation.\n• Occasional errors in spelling and/or word formation may occur, but have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng lượng từ vựng lớn\n• Bài viết sử dụng các từ vựng ít phổ biến và/hoặc thành ngữ,  nhưng đôi khi có thể mắc lỗi trong việc lựa chọn từ ngữ hoặc sử dụng collocation\n• Bài viết mắc một số lỗi về chính tả hoặc cấu tạo từ",
        band: 8,
      },
      {
        eComment:
          "• Full flexibility and precise use are widely evident.\n• A wide range of vocabulary is used accurately and appropriately with very natural and sophisticated control of lexical features.\n• Minor errors in spelling and word formation are extremely rare and have minimal impact on communication.",
        vComment:
          "• Sử dụng nhiều loại từ vựng một cách tự nhiên và linh hoạt để truyền đạt ý nghĩa chính xác và biết cách sử dụng các từ vựng phức tạp \n• Bài viết hiếm mắc lỗi chính tả/cấu tạo từ và gần như không ảnh hưởng đến giao tiếp.",
        band: 9,
      },
    ],
  },
  {
    vName: "Ngữ pháp (Writing)",
    eName: "Grammatical Range & Accuracy",
    apiName: "grammatical_range_accuracy_writing",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Responses of 20 words or fewer are rated at Band 1.\nNo rateable language is evident.",
        vComment:
          "• Bài viết dưới 20 từ được xếp ở Band 1\n• Bài viết hoàn toàn không thể viết thành câu",
        band: 1,
      },
      {
        eComment:
          "• There is little or no evidence of sentence forms (except in memorised phrases).",
        vComment:
          "• Bài viết không thể viết thành câu ngoại trừ những câu đã học thuộc lòng từ trước",
        band: 2,
      },
      {
        eComment:
          "• Sentence forms are attempted, but errors in grammar and punctuation predominate (except in memorised phrases or those taken from the input material). This prevents most meaning from coming through.\n• Length may be insufficient to provide evidence of control of sentence forms.",
        vComment:
          "• Học viên có cố gắng viết câu hoàn chỉnh, nhưng lỗi sai ngữ pháp và dấu câu khiến thông điệp bị bóp méo (ngoại trừ cụm từ học thuộc hoặc lấy từ đề bài)",
        band: 3,
      },
      {
        eComment:
          "• A very limited range of structures is used.\n• Subordinate clauses are rare and simple sentences predominate.\n• Some structures are produced accurately but grammatical errors are frequent and may impede meaning.\n• Punctuation is often faulty or inadequate.",
        vComment:
          "• Bài viết chỉ sử dụng được một lượng rất hạn chế các cấu trúc và hiếm khi sử dụng được mệnh đề phụ thuộc\n• Một số cấu trúc được sử dụng chính xác tuy nhiên thường xuyên sai ngữ pháp và dấu câu",
        band: 4,
      },
      {
        eComment:
          "• The range of structures is limited and rather repetitive.\n• Although complex sentences are attempted, they tend to be faulty, and the greatest accuracy is achieved on simple sentences.\n• Grammatical errors may be frequent and cause some difficulty for the reader.\n• Punctuation may be faulty.",
        vComment:
          "• Bài viết chỉ sử dụng một lượng hạn chế các cấu trúc\n• Học viên có cố gắng đặt những câu phức tạp nhưng những câu này sẽ không chính xác bằng các cấu trúc câu đơn\n• Bài viết thường xuyên mắc lỗi ngữ pháp và dấu câu có thể bị lỗi; lỗi có thể gây ra một số khó khăn cho người đọc",
        band: 5,
      },
      {
        eComment:
          "• A mix of simple and complex sentence forms is used but flexibility is limited.\n• Examples of more complex structures are not marked by the same level of accuracy as in simple structures.\n• Errors in grammar and punctuation occur, but rarely impede communication.",
        vComment:
          "• Bài viết kết hợp sử dụng cấu trúc đơn giản và phức tạp\n• Mắc một số lỗi ngữ pháp và dấu câu nhưng không ảnh hưởng tới truyền đạt thông tin",
        band: 6,
      },
      {
        eComment:
          "• A variety of complex structures is used with some flexibility and accuracy.\n• Grammar and punctuation are generally well controlled, and error-free sentences are frequent.\n• A few errors in grammar may persist, but these do not impede communication.",
        vComment:
          "• Bài viết sử dụng nhiều cấu trúc phức tạp\n• Phần lớn các câu trong bài đều không mắc lỗi \n• Bài viết sử dụng đúng ngữ pháp và dấu câu nhưng có thể mắc một vài lỗi",
        band: 7,
      },
      {
        eComment:
          "• A wide range of structures is flexibly and accurately used.\n• The majority of sentences are error-free, and punctuation is well managed.\n• Occasional, non-systematic errors and inappropriacies occur, but have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng lượng lớn cấu trúc \n• Hầu hết các câu văn trong bài viết đều không mắc lỗi\n• Bài viết rất ít khi mắc lỗi hoặc sử dụng cấu trúc không phù hợp",
        band: 8,
      },
      {
        eComment:
          "• A wide range of structures is used with full flexibility and control.\n• Punctuation and grammar are used appropriately throughout.\n• Minor errors are extremely rare and have minimal impact on communication.",
        vComment:
          "• Bài viết sử dụng lượng lớn cấu trúc một cách tự nhiên và chính xác\n• Bài viết sử dụng dấu câu và ngữ pháp một cách phù hợp và chính xác trong toàn bài\n• Bài viết hiếm mắc lỗi ngữ pháp hầu như không ảnh hưởng đến khả năng truyền đạt",
        band: 9,
      },
    ],
  },
];
export const IS_HIGH_BAND = 1;

export const SecondarySpeakingCriteria = [
  {
    vName: "Nội dung",
    eName: "Content",
    apiName: "secondary_speaking_content",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Trả lời được đủ tối thiểu 1 yêu cầu của bài: có một số chính nhưng ý có thể chưa được triển khai.\n• Không có dẫn chứng hoặc dẫn chứng không phù hợp.",
        vComment:
          "• Trả lời được đủ tối thiểu 1 yêu cầu của bài: có một số chính nhưng ý có thể chưa được triển khai.\n• Không có dẫn chứng hoặc dẫn chứng không phù hợp.",
        band: 0.2,
      },
      {
        eComment:
          "• Trả lời được cơ bản yêu cầu của bài: có khá đầy đủ ý chính nhưng triển khai ý còn rời rạc hoặc có ý không liên quan.\n• Có dẫn chứng, nhưng đôi chỗ dẫn chứng chưa phù hợp.",
        vComment:
          "• Trả lời được cơ bản yêu cầu của bài: có khá đầy đủ ý chính nhưng triển khai ý còn rời rạc hoặc có ý không liên quan.\n• Có dẫn chứng, nhưng đôi chỗ dẫn chứng chưa phù hợp.",
        band: 0.4,
      },
      {
        eComment:
          "• Trả lời khá đầy đủ yêu cầu của bài: đủ ý chính, các ý thống nhất, có liên quan, được triển khai khá rõ ràng.\n• Dẫn chứng khá phù hợp và thuyết phục.",
        vComment:
          "• Trả lời khá đầy đủ yêu cầu của bài: đủ ý chính, các ý thống nhất, có liên quan, được triển khai khá rõ ràng.\n• Dẫn chứng khá phù hợp và thuyết phục.",
        band: 0.6,
      },
      {
        eComment:
          "• Trả lời đầy đủ yêu cầu của bài: đủ ý chính, các ý thống nhất, được triển khai rõ ràng, sâu sắc.\n• Dẫn chứng phù hợp và thuyết phục.",
        vComment:
          "• Trả lời đầy đủ yêu cầu của bài: đủ ý chính, các ý thống nhất, được triển khai rõ ràng, sâu sắc.\n• Dẫn chứng phù hợp và thuyết phục.",
        band: 0.8,
      },
    ],
  },
  {
    vName: "Độ lưu loát, liên kết và phát âm",
    eName: "Fluency & Pronunciation",
    apiName: "secondary_speaking_fluency_pronunciation",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Gặp khó khăn trong việc duy trì tốc độ nói. Nói vấp, lặp lại hoặc nói chậm.\n• Không có hoặc hạn chế phương tiện kết nối.\n• Phát âm hạn chế, còn nhiều lỗi sai phát âm, gây khó hiểu cho người nghe.",
        vComment:
          "• Gặp khó khăn trong việc duy trì tốc độ nói. Nói vấp, lặp lại hoặc nói chậm.\n• Không có hoặc hạn chế phương tiện kết nối.\n• Phát âm hạn chế, còn nhiều lỗi sai phát âm, gây khó hiểu cho người nghe.",
        band: 0.1,
      },
      {
        eComment:
          "• Cơ bản duy trì được tốc độ nói nhưng còn nói vấp, lặp, chậm.\n• Có sử dụng phương tiện kết nối, tuy nhiên còn đơn giản, kết nối không phù hợp.\n• Biết phát âm cơ bản, nhưng chưa chính xác qua phát âm một số âm tiết gây khó hiểu cho người nghe.",
        vComment:
          "• Cơ bản duy trì được tốc độ nói nhưng còn nói vấp, lặp, chậm.\n• Có sử dụng phương tiện kết nối, tuy nhiên còn đơn giản, kết nối không phù hợp.\n• Biết phát âm cơ bản, nhưng chưa chính xác qua phát âm một số âm tiết gây khó hiểu cho người nghe.",
        band: 0.2,
      },
      {
        eComment:
          "• Có khả năng duy trì lời nói khá dài: đôi chỗ lặp, sửa lại, phân vân… và đôi lúc có sự ngập ngừng.\n• Biết cách sử dụng các phương tiện kết nối khá hiệu quả nhưng đôi chỗ chưa phù hợp.\n• Phát âm khá tốt, khá dễ nghe, nhưng còn một số lỗi không rõ ràng khiến người nghe vẫn có thể hiểu.",
        vComment:
          "• Có khả năng duy trì lời nói khá dài: đôi chỗ lặp, sửa lại, phân vân… và đôi lúc có sự ngập ngừng.\n• Biết cách sử dụng các phương tiện kết nối khá hiệu quả nhưng đôi chỗ chưa phù hợp.\n• Phát âm khá tốt, khá dễ nghe, nhưng còn một số lỗi không rõ ràng khiến người nghe vẫn có thể hiểu.",
        band: 0.3,
      },
      {
        eComment:
          "• Nói trôi chảy trong hầu hết thời gian, diễn đạt mạch lạc, rõ ràng.\n• Sử dụng các phương tiện kết nối linh hoạt, phù hợp và hiệu quả.\n• Phát âm tốt, dễ nghe, dễ hiểu, có thể có một số ít lỗi nhỏ.",
        vComment:
          "• Nói trôi chảy trong hầu hết thời gian, diễn đạt mạch lạc, rõ ràng.\n• Sử dụng các phương tiện kết nối linh hoạt, phù hợp và hiệu quả.\n• Phát âm tốt, dễ nghe, dễ hiểu, có thể có một số ít lỗi nhỏ.",
        band: 0.4,
      },
    ],
  },
  {
    vName: "Từ vựng",
    eName: "Lexical Resource",
    apiName: "secondary_speaking_lexical_resource",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Từ vựng liên quan đến chủ đề còn hạn chế, lặp hoặc không phù hợp, gây khó hiểu cho người nghe.",
        vComment:
          "• Từ vựng liên quan đến chủ đề còn hạn chế, lặp hoặc không phù hợp, gây khó hiểu cho người nghe.",
        band: 0.1,
      },
      {
        eComment:
          "• Từ vựng liên quan đến chủ đề cơ bản đủ để diễn đạt ý, một số dùng từ không phù hợp, gây khó hiểu cho người nghe.\n• Biết cách sử dụng cách nói khác để diễn đạt ý.",
        vComment:
          "• Từ vựng liên quan đến chủ đề cơ bản đủ để diễn đạt ý, một số dùng từ không phù hợp, gây khó hiểu cho người nghe.\n• Biết cách sử dụng cách nói khác để diễn đạt ý.",
        band: 0.2,
      },
      {
        eComment:
          "• Từ vựng liên quan đến chủ đề khá đa dạng để diễn đạt ý. Đôi chỗ dùng từ chưa phù hợp nhưng người nghe vẫn hiểu.\n• Biết cách sử dụng từ đồng nghĩa, trái nghĩa, kết hợp từ, cụm động từ, thành ngữ… tuy nhiên đôi chỗ còn mắc lỗi.",
        vComment:
          "• Từ vựng liên quan đến chủ đề khá đa dạng để diễn đạt ý. Đôi chỗ dùng từ chưa phù hợp nhưng người nghe vẫn hiểu.\n• Biết cách sử dụng từ đồng nghĩa, trái nghĩa, kết hợp từ, cụm động từ, thành ngữ… tuy nhiên đôi chỗ còn mắc lỗi.",
        band: 0.3,
      },
      {
        eComment:
          "• Từ vựng liên quan đến chủ đề phong phú, tự nhiên.\n• Sử dụng đa dạng từ đồng nghĩa, trái nghĩa, kết hợp từ, cụm động từ, thành ngữ… với rất ít lỗi.",
        vComment:
          "• Từ vựng liên quan đến chủ đề phong phú, tự nhiên.\n• Sử dụng đa dạng từ đồng nghĩa, trái nghĩa, kết hợp từ, cụm động từ, thành ngữ… với rất ít lỗi.",
        band: 0.4,
      },
    ],
  },
  {
    vName: "Ngữ pháp",
    eName: "Grammatical range & accuracy",
    apiName: "secondary_speaking_grammatical_range_accuracy",
    point: null,
    specificComment: null,
    pointList: [
      {
        eComment:
          "• Sử dụng hầu hết các cấu trúc câu đơn giản.\n• Có nhiều lỗi ngữ pháp, ảnh hưởng lớn đến ý cần diễn đạt.",
        vComment:
          "• Sử dụng hầu hết các cấu trúc câu đơn giản.\n• Có nhiều lỗi ngữ pháp, ảnh hưởng lớn đến ý cần diễn đạt.",
        band: 0.1,
      },
      {
        eComment:
          "• Sử dụng được các câu đơn, câu ghép, câu phức.\n• Còn lỗi sai về ngữ pháp, ảnh hưởng đến ý cần diễn đạt.",
        vComment:
          "• Sử dụng được các câu đơn, câu ghép, câu phức.\n• Còn lỗi sai về ngữ pháp, ảnh hưởng đến ý cần diễn đạt.",
        band: 0.2,
      },
      {
        eComment:
          "• Sử dụng đa dạng các cấu trúc câu, tuy nhiên còn lỗi, nhất là câu phức.\n• Có rất ít lỗi ngữ pháp, đôi chỗ ảnh hưởng đến ý cần diễn đạt.",
        vComment:
          "• Sử dụng đa dạng các cấu trúc câu, tuy nhiên còn lỗi, nhất là câu phức.\n• Có rất ít lỗi ngữ pháp, đôi chỗ ảnh hưởng đến ý cần diễn đạt.",
        band: 0.3,
      },
      {
        eComment:
          "• Sử dụng đa dạng, linh hoạt cấu trúc câu.\n• Còn một vài lỗi ngữ pháp nhỏ nhưng hầu như không ảnh hưởng đến ý cần diễn đạt.",
        vComment:
          "• Sử dụng đa dạng, linh hoạt cấu trúc câu.\n• Còn một vài lỗi ngữ pháp nhỏ nhưng hầu như không ảnh hưởng đến ý cần diễn đạt.",
        band: 0.4,
      },
    ],
  },
];

const createSecondarySpeakingPoint = (band, comment) => ({
  eComment: comment,
  vComment: comment,
  band,
});

export const SecondarySpeakingCriteriaV2 = [
  {
    vName: 'Nội dung',
    eName: 'Content',
    apiName: 'secondary_speaking_content',
    point: null,
    specificComment: null,
    pointList: [
      createSecondarySpeakingPoint(1, '- Trả lời được đủ tối thiểu 1 yêu cầu của bài: có một số chính nhưng ý có thể chưa được triển khai.\n- Không có dẫn chứng hoặc dẫn chứng không phù hợp.'),
      createSecondarySpeakingPoint(2, '- Trả lời được cơ bản yêu cầu của bài: có khá đầy đủ ý chính nhưng triển khai ý còn rời rạc hoặc có ý không liên quan.\n- Có dẫn chứng, nhưng đôi chỗ dẫn chứng chưa phù hợp.'),
      createSecondarySpeakingPoint(3, '- Trả lời khá đầy đủ yêu cầu của bài: đủ ý chính, các ý thống nhất, có liên quan, được triển khai khá rõ ràng.\n- Dẫn chứng khá phù hợp và thuyết phục.'),
      createSecondarySpeakingPoint(4, '- Trả lời đầy đủ yêu cầu của bài: đủ ý chính, các ý thống nhất, được triển khai rõ ràng, sâu sắc.\n- Dẫn chứng phù hợp và thuyết phục.'),
    ],
  },
  {
    vName: 'Độ lưu loát, liên kết và phát âm',
    eName: 'Fluency & Pronunciation',
    apiName: 'secondary_speaking_fluency_pronunciation',
    point: null,
    specificComment: null,
    pointList: [
      createSecondarySpeakingPoint(0.5, '- Gặp khó khăn trong việc duy trì tốc độ nói. Nói vấp, lặp lại hoặc nói chậm.\n- Không có hoặc hạn chế phương tiện kết nối.\n- Phát âm hạn chế, còn nhiều lỗi sai phát âm, gây khó hiểu cho người nghe.'),
      createSecondarySpeakingPoint(1, '- Cơ bản duy trì được tốc độ nói nhưng còn nói vấp, lặp, chậm.\n- Có sử dụng phương tiện kết nối, tuy nhiên còn đơn giản, kết nối không phù hợp.\n- Biết phát âm cơ bản, nhưng chưa chính xác qua phát âm một số âm tiết gây khó hiểu cho người nghe.'),
      createSecondarySpeakingPoint(1.5, '- Có khả năng duy trì lời nói khá dài: đôi chỗ lặp, sửa lại, phân vân… và đôi lúc có sự ngập ngừng.\n- Biết cách sử dụng các phương tiện kết nối khá hiệu quả nhưng đôi chỗ chưa phù hợp.\n- Phát âm khá tốt, khá dễ nghe, nhưng còn một số lỗi không rõ ràng khiến người nghe vẫn có thể hiểu.'),
      createSecondarySpeakingPoint(2, '- Nói trôi chảy trong hầu hết thời gian, diễn đạt mạch lạc, rõ ràng.\n- Sử dụng các phương tiện kết nối linh hoạt, phù hợp và hiệu quả.\n- Phát âm tốt, dễ nghe, dễ hiểu, có thể có một số ít lỗi nhỏ.'),
    ],
  },
  {
    vName: 'Từ vựng',
    eName: 'Lexical Resource',
    apiName: 'secondary_speaking_lexical_resource',
    point: null,
    specificComment: null,
    pointList: [
      createSecondarySpeakingPoint(0.5, 'Từ vựng liên quan đến chủ đề còn hạn chế, lặp hoặc không phù hợp, gây khó hiểu cho người nghe.'),
      createSecondarySpeakingPoint(1, '- Từ vựng liên quan đến chủ đề cơ bản đủ để diễn đạt ý, một số dùng từ không phù hợp, gây khó hiểu cho người nghe.\n- Biết cách sử dụng cách nói khác để diễn đạt ý.'),
      createSecondarySpeakingPoint(1.5, '- Từ vựng liên quan đến chủ đề khá đa dạng để diễn đạt ý. Đôi chỗ dùng từ chưa phù hợp nhưng người nghe vẫn hiểu.\n- Biết cách sử dụng từ đồng nghĩa, trái nghĩa, kết hợp từ, cụm động từ, thành ngữ… tuy nhiên đôi chỗ còn mắc lỗi.'),
      createSecondarySpeakingPoint(2, '- Từ vựng liên quan đến chủ đề phong phú, tự nhiên.\n- Sử dụng đa dạng từ đồng nghĩa, trái nghĩa, kết hợp từ, cụm động từ, thành ngữ… với rất ít lỗi.'),
    ],
  },
  {
    vName: 'Ngữ pháp',
    eName: 'Grammatical range & accuracy',
    apiName: 'secondary_speaking_grammatical_range_accuracy',
    point: null,
    specificComment: null,
    pointList: [
      createSecondarySpeakingPoint(0.5, '- Sử dụng hầu hết các cấu trúc câu đơn giản.\n- Có nhiều lỗi ngữ pháp, ảnh hưởng lớn đến ý cần diễn đạt.'),
      createSecondarySpeakingPoint(1, '- Sử dụng được các câu đơn, câu ghép, câu phức.\n- Còn lỗi sai về ngữ pháp, ảnh hưởng đến ý cần diễn đạt.'),
      createSecondarySpeakingPoint(1.5, '- Sử dụng đa dạng các cấu trúc câu, tuy nhiên còn lỗi, nhất là câu phức.\n- Có rất ít lỗi ngữ pháp, đôi chỗ ảnh hưởng đến ý cần diễn đạt.'),
      createSecondarySpeakingPoint(2, '- Sử dụng đa dạng, linh hoạt cấu trúc câu.\n- Còn một vài lỗi ngữ pháp nhỏ nhưng hầu như không ảnh hưởng đến ý cần diễn đạt.'),
    ],
  },
];
